module.exports = __webpack_public_path__ + "img/feature-coach@2x.360280ee.png";